import React, { FC, HTMLProps } from 'react';
import classNames from 'classnames';
import styles from './paper.module.scss';

type Props = {
  level?: 0 | 1;
  className?: string;
} & HTMLProps<HTMLDivElement>;

export const Paper: FC<Props> = ({
  children,
  level = 1,
  className = '',
  ...props
}) => (
  <div
    className={classNames(
      styles.container,
      {
        [styles.level]: level === 1,
      },
      className,
    )}
    {...props}
  >
    {children}
  </div>
);
